export default "__VITE_ASSET__Cp3CHU98__"